import { render, staticRenderFns } from "./getTimeCellElectricshock.vue?vue&type=template&id=eb744992&scoped=true&"
import script from "./getTimeCellElectricshock.vue?vue&type=script&lang=js&"
export * from "./getTimeCellElectricshock.vue?vue&type=script&lang=js&"
import style0 from "./getTimeCellElectricshock.vue?vue&type=style&index=0&id=eb744992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb744992",
  null
  
)

export default component.exports